import styled from "styled-components";

export const TaskListItemWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
  border: ${({ theme }) =>
    `${theme.border.thin} solid ${theme.colors.primary}`};
  border-radius: ${({ theme }) => `${theme.borderRadius.l}`};

  position: relative;
  width: 100%;
  margin-bottom: 15px;

  padding: 15px 20px 9px 20px;
`;
